import React, { createContext, useState, useEffect, useContext } from 'react';
import { API_URL } from '../config/api';

const ContactContext = createContext();

export const ContactProvider = ({ children }) => {
  const [contactSettings, setContactSettings] = useState({
    tfn: '+1-888-859-0441',
    email: 'support@flytraveldeals.us',
    address: '1309 Coffeen Ave STE 1200, Sheridan, WY 82801, USA',
    workingHours: 'Mon-Sun 24/7',
    billingAddress: '1309 Coffeen Ave STE 1200, Sheridan, WY 82801, USA',
    copyrightText: '© {year} FlyTravelDeals.us. All rights reserved.',
    headerColor: '#667eea',
    headerGradient: '#764ba2',
    footerColor: '#2d3748',
    footerGradient: '#1a202c',
    logoUrl: ''
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchContactSettings();
  }, []);

  const fetchContactSettings = async () => {
    try {
      const response = await fetch(`${API_URL}/api/admin/public/contact-settings`);
      const data = await response.json();
      if (data.success && data.settings) {
        setContactSettings(data.settings);
      }
    } catch (error) {
      console.error('Error fetching contact settings:', error);
      // Keep default values on error
    } finally {
      setLoading(false);
    }
  };

  return (
    <ContactContext.Provider value={{ contactSettings, loading, refreshSettings: fetchContactSettings }}>
      {children}
    </ContactContext.Provider>
  );
};

export const useContact = () => {
  const context = useContext(ContactContext);
  if (!context) {
    throw new Error('useContact must be used within ContactProvider');
  }
  return context;
};

export default ContactContext;
